import { get, post } from '@/service/request';
import { requestOptions as options } from '@/service/requestOptions';

const url = 'api/AG';
// errorDialog跳dialog , repeatRequestCancel可以重複請求
// const options = { errorDialog: true, secure: false, baseURL: true, repeatRequestCancel: false };

// 保戶進入投資配息/提解給付方式變更前，取得先前投資配息/提解給付方式變更記錄
export function getInfoAG() {
    return get(`${url}/info`);
}

// 保戶進入投資配息/提解給付方式變更，取得提解給付方式下拉式選單
export function getDividendInfoAG() {
    return get(`${url}/dividendInfo`);
}

// 送出投資配息/提解給付方式變更申請
export function submitAG(data) {
    return post(`${url}/submit`, data, { ...options, repeatRequestCancel: true });
}
